export default function ({ children }) {
    return <div style={{ textAlign: 'center', margin: '50px' }}>{children}</div>
}
